
import { Component, Vue } from "vue-property-decorator";
// import { isLoginShareholderSession, clearLoginShareholderSession } from "@/lib/functions";
import store from "@/store";

@Component
export default class Logout extends Vue {
  private async mounted() {
    const isShareholderGroup = store.getters["auth/isShareholder"];
    // const isShareholder = await isLoginShareholderSession();
    const to = this.$route.query.to;
    try {
      const response = await store.dispatch("auth/logout");
      const lang = store.getters["auth/lang"];
      if (response) {
        let loginPath = lang === "ja" ? "/login" : `/${lang}/login`;
        if (isShareholderGroup) {
          loginPath = "/login-shareholder";
        }
        // if (isShareholder) {
        //   await clearLoginShareholderSession();
        // }
        if (to) {
          loginPath = to as string;
        }
        this.$router.replace(loginPath as string);
      } else {
        const topPath = lang === "ja" ? "/" : `/${lang}`;
        // if (isShareholder) {
        //   await clearLoginShareholderSession();
        // }
        this.$router.replace(topPath as string);
      }
    } catch (e) {
      console.error(e);
      const err = e as { status?: number };
      this.$router.replace({
        path: "/error",
        query: { status: String(err.status != null ? err.status : 500) },
      });
    }
  }
}
